import React, { useState, useRef, useEffect } from 'react';
import BrandLogo from '../../../../../assets/icon/logo-beelajar-horizontal_143x40.svg';
import BrandLogoWhite from '../../../../../assets/img/logo-beelajar-white.png';
import Grid from '../../../../../assets/icon/ic_beelajar_grid-on-sharp.svg';
import './styles.scss';
import ApplicationBar from './ApplicationBar';
import { UserAuth } from '../../../../../types/user';
import useLocalStorage from '../../../../../hooks/useUserData';
import { BRAND_LOGO } from '../../../../../constants';
import { getSharepointCdnFile } from '../../../../../utilities';
import { Image } from '@mantine/core';
import { Link } from 'react-router-dom';
import { ThemeSystem } from '../../../../../views/my-learning/dashboard/themeColor';

interface NavigationBrandProps {
  user: UserAuth;
  theme: ThemeSystem;
}

const NavigationBrand: React.FC<NavigationBrandProps> = ({ user, theme }) => {
  const [brandImage, setBrandImage] = useLocalStorage(BRAND_LOGO, null);
  const [openApps, setOpenApps] = useState<boolean>(false);
  const [brandLogo, setBrandLogo] = useState(null);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        ref.current &&
        openApps &&
        !ref.current.contains(event.target as Node)
      ) {
        setOpenApps(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openApps]);

  useEffect(() => {
    if (brandImage) {
      const filterLogo = brandImage.filter((item) => item.code === '002');
      setBrandLogo(getSharepointCdnFile(filterLogo[0].imageFilePath));
    }
  }, [brandImage]);

  return (
    <section className="wrapper" ref={ref}>
      <div className="container">
        <div
          className="app-grid-logo"
          style={{
            borderRight: '0.75px solid #000000'
          }}
          onClick={() => setOpenApps(!openApps)}
        >
          <img
            style={{
              width: '40px',
              height: '40px',
              margin: '0'
            }}
            src={Grid}
            alt="grid-on-sharp"
          />
        </div>
        <Link to="/" className="brand-logo">
          <div className="brand-logo">
            <Image
              src={
                theme?.type === 'dark' ? BrandLogoWhite : brandLogo || BrandLogo
              }
              height={70}
              width={180}
              alt="beelajar-horizontal"
              fit="contain"
            />
          </div>
        </Link>
      </div>
      {
        <div className={'other-sidebar-app ' + (openApps ? 'open' : '')}>
          <ApplicationBar
            onBtnToogler={() => setOpenApps(!openApps)}
            data={user.appls}
            user={user}
          />
        </div>
      }
    </section>
  );
};

export default NavigationBrand;
